import styled from 'styled-components';
import { LIGHT_YELLOW, WHITE, DARK_VIOLET, NEUTRAL_100, GRAYSCALE_400, GRAYSCALE_500, VIOLET_500, BLACK } from '@styles/colors';
import { INTER } from '@styles/fonts';
import { safeAreaInset } from '@lib/telegram';
import { JIDRCurrencyPng } from "@components/CurrencyIcon/CurrencyIcon";

// Main container
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

// Content container
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 12px 15vh 12px;
  overflow-y: auto;
`;

// Button group container
export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: ${WHITE};
  z-index: 1000;
`;

export const BankLogoContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 1px solid ${NEUTRAL_100};
  overflow: hidden;
  transform: translateX(2.5px);
`;

export const BankLogo = styled.img`
  width: 100%;
  height: 100%;
`;

export const JIDRCurrency = styled(JIDRCurrencyPng)`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  transform: translateX(-2.5px);
`;

// Instructions container
export const InstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

// BankLogoAndName components
export const BankLogoNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const BankLogoRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BankInfoText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BankDisplayName = styled.span`
  font-family: ${INTER.medium};
  font-weight: 500;
  font-size: 13px;
  color: ${DARK_VIOLET};
`;

export const BankCodeText = styled.span`
  font-family: ${INTER.regular};
  font-weight: 400;
  font-size: 13px;
  color: ${GRAYSCALE_400};
`;

// TransferPrompt component
export const TransferPromptText = styled.span`
  font-family: ${INTER.regular};
  font-weight: 400;
  font-size: 16px;
  color: ${BLACK};
  text-align: center;
`;

export const TransferPromptBold = styled.span`
  font-family: ${INTER.bold};
  font-weight: 700;
`;

// ExpirationDate component
export const ExpirationDateContainer = styled.div`
  background-color: ${LIGHT_YELLOW};
  padding: 6px 8px;
  border-radius: 8px;
`;

export const ExpirationDateText = styled.span`
  font-family: ${INTER.regular};
  font-weight: 400;
  font-size: 13px;
  color: ${DARK_VIOLET};
`;

export const ExpirationDateBold = styled.span`
  font-family: ${INTER.semiBold};
  font-weight: 600;
`;

// VirtualNumberBox components
export const VirtualNumberBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${NEUTRAL_100};
  padding: 20px 16px;
  border-radius: 16px;
`;

export const VirtualNumberBoxLabel = styled.span`
  font-family: ${INTER.semiBold};
  font-weight: 600;
  font-size: 12px;
  color: ${DARK_VIOLET};
`;

export const VirtualNumberBoxRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0px;
`;

export const VirtualAccountNumberText = styled.span`
  font-family: ${INTER.medium};
  font-weight: 500;
  font-size: 20px;
  color: ${VIOLET_500};
`;

export const TotalAmountText = styled.span`
  font-family: ${INTER.bold};
  font-weight: 700;
  font-size: 16px;
  color: ${DARK_VIOLET};
`;

export const EquivalentText = styled.span`
  font-family: ${INTER.regular};
  font-weight: 400;
  font-size: 13px;
  color: ${GRAYSCALE_500};
`;

export const VirtualNumberDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${NEUTRAL_100};
  margin: 8px 0px;
`;

// CustomSpacer component
export const Spacer = styled.div<{ space: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: ${props => props.space / 2}px;
`;
